module.exports = __webpack_public_path__ + "media/stylesheets/images/media/advertising_belcy_bg-69d1ec7d4b288bfe911848fe3f7a47e7.jpg";